/**
 * CDN base URL for static assets (GLB models, textures, sprites, data JSONs).
 *
 * - Dev: empty string → assets served from local /public via Vite dev server
 * - Prod: set VITE_CDN_URL=https://assets.corpllm.io in build env
 */
export const CDN_BASE = (import.meta.env.VITE_CDN_URL as string ?? '').replace(/\/$/, '');
